<template>
	<div class="d-flex" v-if="!checkApprovalChecks">
		<v-tooltip v-for="role in roles_needed" :key="role" top>
			<template v-slot:activator="{ on, attrs }">
				<v-btn class="custom-btn mx-1" :class="{ 'readonly-disabled': read_only }" plain :disabled="loading" @click="read_only ? null : setApprovalCheck(role)"
								v-bind="attrs"
								v-on="on">
					<div class="d-flex flex-column justify-center align-center text-center">
						<v-icon :color="getColor(role)" :size="icon_size">{{getIcon(role)}}</v-icon>
						<div class="custom-jobtype-text">{{getRoleName(role)}}</div>
					</div>
				</v-btn>
			</template>
			<span>{{getName(role)}}</span>
		</v-tooltip>
	</div>
	<v-menu
		v-else
		v-model="fab"
		:offset-y="position !== 'left' && position !== 'right'"
		:offset-x="position === 'left' || position === 'right'"
		:top="position === 'top'"
		:left="position === 'left' || position === 'bottom-left'"
		:right="position === 'right'"
		:close-on-content-click="false"
		class="custom-speed-dial"
	>
		<template v-slot:activator="{ on: menuOn }">
			<v-btn class="custom-btn mx-1" :class="{ 'readonly-disabled': read_only }" plain :disabled="loading" v-bind="menuOn" @click="read_only ? null : fab = !fab">
				<div class="d-flex flex-column justify-center align-center text-center">
					<v-icon v-if="fab" color="green" :size="icon_size">mdi-close</v-icon>
					<v-icon v-else color="green" :size="icon_size">mdi-check-circle-outline</v-icon>
				</div>
			</v-btn>
		</template>
		<div style="border-radius: 8px; border: 2px solid #5E85EF; background-color: white; padding: 0px; display: flex; flex-direction: column; align-items: center;">
			<v-tooltip v-for="role in roles_needed" :key="role" top>
				<template v-slot:activator="{ on, attrs }">
					<v-btn class="custom-btn mx-1" :class="{ 'readonly-disabled': read_only }" plain :disabled="loading" @click="read_only ? null : setApprovalCheck(role)"
									v-bind="attrs"
									v-on="on">
						<div class="d-flex flex-column justify-center align-center text-center">
							<v-icon :color="getColor(role)" :size="icon_size">{{getIcon(role)}}</v-icon>
							<div class="custom-jobtype-text">{{getRoleName(role)}}</div>
						</div>
					</v-btn>
				</template>
				<span>{{getName(role)}}</span>
			</v-tooltip>
		</div>
	</v-menu>
</template>

<script>
import moment from 'moment'
import {setApprovalCheck} from '@/helpers/api/approvalchecks'

export default {
	name: 'ApprovalChecks',
	components: {},
	props: {
		item: {
			type: Object,
			required: true
		},
		item_type: {
			type: String,
			required: true
		},
		roles_needed: {
			type: Array,
			required: true
		},
		icon_size: {
			type: String,
			default: '24'
		},
		position: {
			type: String,
			default: 'top',
			validator: v => ['top', 'bottom', 'left', 'right', 'bottom-left'].includes(v)
		},
		read_only: {
			type: Boolean,
			default: false
		}
	},
  computed: {
		availableProfiles() {
			const creator = { id: -1, name: 'Creador',       description: 'Creador del ítem' }
			const responsible = { id: -2, name: 'Responsable', description: 'Responsable del ítem' }
			return [creator, responsible, ...this.$store.projectsStore.state.projectProfiles]
		},
		approval_profiles_needed(){
			return this.roles_needed.map((roleId) => {
				const profile = this.availableProfiles.find(p => p.id === roleId)
				return profile ? { name: profile.name } : { name: '' }
			})
		},
		approval_checks(){
			return this.item.approval_checks.filter((check) => {
				return check.raw_type == this.item_type
			})
		},
		checkApprovalChecks(){
			return this.roles_needed.every((roleId) => {
				if(roleId === -1){
					return this.approval_checks.some((item) => {
						return item.user_id == this.item.created_by
					})
				}
				if(roleId === -2){
					return this.approval_checks.some((item) => {
						return item.user_id == this.item.responsable
					})
				}
				return this.approval_checks.some((item) => {
					return item.job_type == roleId
				})
			})
		}
  },
	data: () => ({
		loading: false,
		fab: false
	}),
	mounted(){
		// this.$store.projectsStore.state.selectedProject.job_type.id
	},
	methods: {
		getRoleId(roleId){
			return roleId
		},
		getRoleName(roleId){
			const profile = this.availableProfiles.find(p => p.id === roleId)
			return profile ? profile.name : ''
		},
		updateApprovalCheck(roleId, status){
			let newApprovalChecks = [...this.approval_checks]
			
			if(roleId === -1){
				if(status) {
					newApprovalChecks.push({
						user_id: this.$store.userStore.state.userInfo.id,
						user: this.$store.userStore.state.userInfo,
						updated_at: new Date()
					})
				} else {
					newApprovalChecks = newApprovalChecks.filter(a => a.user_id !== this.$store.userStore.state.userInfo.id)
				}
			} else {
				if(status) {
					newApprovalChecks.push({
						job_type: roleId,
						user: this.$store.userStore.state.userInfo,
						updated_at: new Date()
					})
				} else {
					newApprovalChecks = newApprovalChecks.filter(a => a.job_type !== roleId)
				}
			}
			
			this.item.approval_checks = newApprovalChecks
		},
		async setApprovalCheck(roleId){
			if(this.item_type === 'rdi' && (!this.item.official_interactions || this.item.official_interactions.length === 0)){
				const data = {
					message: 'Para iniciar el cierre de esta RDI, debe existir al menos una Respuesta Oficial.',
					title: 'Error',
					created: new Date(),
					type: 'danger',
					icon: 'mdi-close-octagon',
					color: '#F4516C'
				}
				this.$store.globalStore.dispatch('addMessage', data)
				return
			}
			if(this.checkUserApproval(roleId)){
				const current_status = this.getCurrentStatus(roleId)
				const new_status = !current_status
				
				// Optimistic update
				this.updateApprovalCheck(roleId, new_status)
				
				const data = {
					item_id: this.item.id,
					item_type: this.item_type,
					new_status: new_status
				}
				this.loading = true
				try {
					await setApprovalCheck(data)
					this.$emit('onChange')
				} catch (error) {
					// Revertir cambio en caso de error
				this.updateApprovalCheck(roleId, current_status)
					const errorData = {
						message: 'Error al actualizar la aprobación. Por favor intenta nuevamente.',
						title: 'Error',
						created: new Date(),
						type: 'danger',
						icon: 'mdi-close-octagon',
						color: '#F4516C'
					}
					this.$store.globalStore.dispatch('addMessage', errorData)
				}
				this.loading = false
			}
		},
		checkUserApproval(roleId){
			if(roleId === -1){
				//Creador
				const is_creator = this.$store.userStore.state.userInfo.id == this.item.created_by
				if(!is_creator){
					const data = {
						message: 'No eres el creador de este elemento.',
						title: 'Error',
						created: new Date(),
						type: 'danger',
						icon: 'mdi-close-octagon',
						color: '#F4516C'
					}
					this.$store.globalStore.dispatch('addMessage', data)
					return false
				}
				return true
			}
			
			const is_job = this.$store.projectsStore.state.selectedProject.job_type.id == roleId
			if(!is_job){
				const profile = this.availableProfiles.find(p => p.id === roleId)
				const profileName = profile ? profile.name : 'Perfil'
				const data = {
					message: 'En el proyecto de este elemento no eres un usuario ' + profileName + '.',
					title: 'Error',
					created: new Date(),
					type: 'danger',
					icon: 'mdi-close-octagon',
					color: '#F4516C'
				}
				this.$store.globalStore.dispatch('addMessage', data)
				return false
			}
			return true
		},
		getCurrentStatus(roleId){
			if(roleId === -1){
				//Creador
				const present = this.approval_checks.some((item) => {
					return item.user_id == this.item.created_by
				})
				return present
			}
			
			const present = this.approval_checks.some((item) => {
				return item.job_type == roleId
			})
			return present
		},
		getColor(roleId){
			if(roleId === -1){
				//Creador
				const present = this.approval_checks.some((item) => {
					return item.user_id == this.item.created_by
				})
				return present ? 'green':'#DD5050'
			}
			if(roleId === -2){
				//Responsable
				const present = this.approval_checks.some((item) => {
					return item.user_id == this.item.responsable
				})
				return present ? 'green':'#DD5050'
			}
			
			const present = this.approval_checks.some((item) => {
				return item.job_type == roleId
			})
			return present ? 'green':'#DD5050'
		},
		getIcon(roleId){
			if(roleId === -1){
				//Creador
				const present = this.approval_checks.some((item) => {
					return item.user_id == this.item.created_by
				})
				return present ? 'mdi-check-circle-outline':'mdi-circle-outline'
			}
			if(roleId === -2){
				//Responsable
				const present = this.approval_checks.some((item) => {
					return item.user_id == this.item.responsable
				})
				return present ? 'mdi-check-circle-outline':'mdi-circle-outline'
			}
			
			const present = this.approval_checks.some((item) => {
				return item.job_type == roleId
			})
			return present ? 'mdi-check-circle-outline':'mdi-circle-outline'
		},
		getName(roleId){
			if(roleId === -1){
				//Creador
				const user = this.approval_checks.find((item) => {
					return item.user_id == this.item.created_by
				})
				if(user){
					return user.user.name + ' - ' + moment(user.updated_at).format('DD/MM/YYYY HH:mm')
				}
				return '--'
			}
			if(roleId === -2){
				//Responsable
				const user = this.approval_checks.find((item) => {
					return item.user_id == this.item.responsable
				})
				if(user){
					return user.user.name + ' - ' + moment(user.updated_at).format('DD/MM/YYYY HH:mm')
				}
				return '--'
			}
			
			const user = this.approval_checks.find((item) => {
				return item.job_type == roleId
			})
			if(user){
				return user.user.name + ' - ' + moment(user.updated_at).format('DD/MM/YYYY HH:mm')
			}
			return '--'
		}
	}
};
</script>

<style scoped>
	.custom-btn,
	.custom-btn:disabled {
		height: auto !important;
		min-height: unset !important;
		min-width: unset !important;
		padding: 0 !important;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		background-color: transparent !important;
		box-shadow: none !important;
		border: none;
	}
	.custom-name-text{
		font-size: 8px;
		color: grey;
	}
	.custom-jobtype-text{
		font-size: 9px;
		color: grey;
	}
	.custom-btn.v-btn--plain:not(.v-btn--active):not(.v-btn--loading):not(:focus):not(:hover) .v-btn__content{
		opacity: 0.8;
	}
	.custom-speed-dial{
		position: relative;
	}
	.custom-speed-dial.v-speed-dial--top{
		top: 0;
	}
	.custom-speed-dial.v-speed-dial--bottom{
		bottom: 0;
	}
	.custom-speed-dial .v-speed-dial__list {
		background-color: white !important; /* Fondo blanco */
		border-radius: 50%; /* Opcional: redondea los bordes */
		box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.2); /* Opcional: añade sombra */
	}
	.readonly-disabled:hover,
	.readonly-disabled:active,
	.readonly-disabled:focus {
		opacity: 0.8 !important;
	}
	.readonly-disabled:active::before {
		display: none !important;
	}
</style>